import PublicTmpVideoSelect from '@/weappTmps/publicTmps/SPPvideoSelect'

// 第三方组件
import draggable from 'vuedraggable'
// 组件
import imgPicker from '@/weappTmps/managerTmps/imageselect'
import linkSetter from '@/weappTmps/managerTmps/template_links'
import goodsSelect from '@/weappTmps/managerTmps/goodsSelect'
import couponPicker from '@/weappTmps/managerTmps/coupon_picker'
// 店铺装修组件
// view层组件
import film from '@/weappTmps/managerTmps/template/film'

// control层组件
import template_editor_coupon from '@/weappTmps/managerTmps/template_editor/coupon'
import filmEditor from '@/weappTmps/managerTmps/template_editor/film'

// import { formTmpPackage, managerTmpPackage } from '@/weappTmps/config.js'
import { TmpPackage } from '@/weappTmps/config.js'

console.log('TmpPackage', TmpPackage)

function initTmps (tmps, type) {
  const nTmps = {}
  // console.log(`initTmps-tmps:${type}`,tmps)
  let name = '',
    paths = []
  for (let i in tmps) {
    paths = i.split('/')
    name = tmps[i].name || paths[0] + '_' + paths[1]
    nTmps[name] = tmps[i]
    // console.log(i,' ',name)
  }
  // console.log('nTmps',nTmps)
  return nTmps
}

const TmpPackageKeyList = ['activeTmps', 'formTmps', 'managerTmps', 'comps']
let TmpPackageMap = {}
for (let i in TmpPackage) {
  if (TmpPackageKeyList.indexOf(i) > -1) {
    TmpPackageMap = Object.assign(TmpPackageMap, initTmps(TmpPackage[i].tmps))
  }
}
console.log('TmpPackageList', TmpPackageMap)
const staticTmps = {
  // test form cmp
  PublicTmpVideoSelect,
  // 旧代码
  film,
  template_editor_coupon,
  filmEditor,
  // // 旧代码
  // // 其他组件
  imgPicker,
  linkSetter,
  goodsSelect,
  couponPicker,
  // 第三方组件
  draggable
}

export const mergeTmps = Object.assign(staticTmps, TmpPackageMap)
console.log('mergeTmps', mergeTmps)
export default {
  // mixins:[mixin],
  components: {
    ...mergeTmps
  }
}
